<template>
	<div class="game-item">
		<div class="l">
			<div class="img-wrapper">
				<img :src="src" alt="">
			</div>
		</div>
		<div class="r">
			<div class="content">
				<h4 class="title">{{title}}</h4>
				<p class="subtitle" v-for="(item, index) in contentDataList" :key="index">{{item}}</p>
			</div>
			<div class="link-img">
				<div class="l">
					<div class="img-wrapper">
						<a :href="iosUrl" target="_blank">
							<img src="../assets/img/apple-ios.png" alt="">
						</a>
					</div>
				</div>
				<div class="r">
					<div class="img-wrapper">
						<a :href="androidUrl" target="_blank">
							<img src="../assets/img/google-play.png" alt="">
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'GameItem',

		props: {
			title: {
				type: String,
			},
			content: {
				type: [String, Array],
			},
			src: {
				type: String,
			},
			iosUrl: {
				type: String,
			},
			androidUrl: {
				type: String,
			},
		},

		computed: {
			contentDataList() {
				const { content } = this;
				if( Array.isArray(content) ){
					return content;
				}else{
					return [content]
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.mobile {
		.game-item {
			width: 90%;
			flex-direction: column;
			& > .l {
				margin-bottom: 15px;
			}

			.link-img {
				flex-direction: column;

				& > .l, .r {
					text-align: center;
				}

				& > .l {
					margin-bottom: 12px;
				}
			}
		}
	}
	.game-item {
		width: 80%;
		margin: 0 auto;
		display: flex;
		padding: 80px 0;

		.l, .r {
			flex: 1;
			margin-left: 1.04166666%;
			margin-right: 1.04166666%;
		}

		.l {
			.img-wrapper {
				width: 300px;
				height: 603px;
				overflow: hidden;
				margin: 0 auto;

				img {
					display: block;
				    width: 100%;
				}
			}
		}
		.r {
			align-self: center;
		}

		.content {
			margin-bottom: 45px;

			.title {
				font-family: lato, helvetica, sans-serif;
				line-height: 1.2;
				text-align: center;
				margin-bottom: 10px;
				font-weight: 700;
				font-size: 44px;
				margin-bottom: 15px;
			}

			.subtitle {
				line-height: 1.45;
				font-size: 20px;
				font-weight: 400;
				font-family: lato, helvetica, sans-serif;
				text-align: center;
				color: #62686f;
				margin-bottom: 10px;
			}
		}

		.link-img {
			display: flex;
			.l, .r {
				flex: 1;
				margin-right: 10px;

				.img-wrapper {
					height: 51px;
					width: 183px;
					display: inline-block;
				}

				img {
					display: block;
					height: 100%;
					cursor: pointer;
				}
			}
			.l {
				text-align: right;
			}
			.r {
				text-align: left;
			}
		}
	}
</style>